module.exports = __webpack_public_path__ + "img/registration-wizard-bg.a413d45.png";